module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/ladder-2-a617377a98ce9f76.png"+" 223w",
        images: [{path: __webpack_public_path__ + "assets/images/ladder-2-a617377a98ce9f76.png",width: 223,height: 464}],
        src: __webpack_public_path__ + "assets/images/ladder-2-a617377a98ce9f76.png",
        toString: function(){return __webpack_public_path__ + "assets/images/ladder-2-a617377a98ce9f76.png"},
        
        width: 223,
        height: 464
      }